import ReactDOM from 'react-dom/client'

import './index.css'
import './i18n'
import { appVersion, appHash } from './config/app'
import { configureLangHeader } from './libs/services'
import i18n from './i18n'
import { initSentry } from './libs/sentry'
import Root from './Root'

// Log app version and hash on startup (matches v2 behavior)
console.info(`App version: v${appVersion}`)
console.info(`App hash id: ${appHash}`)

initSentry()
configureLangHeader(i18n.language)

ReactDOM.createRoot(document.getElementById('root')).render(<Root />)
